import type {
  SearchProductsRequestBodyProto,
  SearchProductsResponseProto,
} from "@noom/noom-contracts/noom_contracts/billing/user_aware/product_search_service";

import { appConfig } from "src/config";
import { send } from "src/utils/fetch";
import { trackTask } from "src/utils/monitoring/events/tasks";

/**
 * Searches product catalog for the subscription sale items of given products
 */
export async function productSearch(
  productNames: string[]
): Promise<SearchProductsResponseProto> {
  const body: Partial<SearchProductsRequestBodyProto> = {
    customerType: "CONSUMER",
    subscriptionSearchFilters: productNames.map((productName) => ({
      productName,
    })),
  };

  const task = trackTask("UserAwareSearch", {
    subscriptionFiltersCount: productNames.length,
  });
  task.start();

  try {
    const response = await send<SearchProductsResponseProto>(
      "POST",
      `${appConfig.BILLING_CORE_API_URL}/billing/v2/products/userAwareSearch`,
      body
    );
    task.success();
    return response;
  } catch (error) {
    task.failed(error);
    throw error;
  }
}
